import * as React from 'react';

import { useDispatch } from 'react-redux'
import { setOperation } from '../operation/operationSlice';

import DataList from '../../components/controls/datagrid/DataList';
import DataColumn from '../../components/controls/datagrid/DataColumn';

export default (props: { controller: string, items: any }) => {
    const dispatch = useDispatch()
    const onRowClick = (e: any, data: any) => {
        e.preventDefault()
        dispatch(setOperation("read", props.controller, { index: data }))
    }

    return (
        <>
            <DataList items={props.items} onRowClick={onRowClick} >                
                <DataColumn kid='column1' name='Codice' fieldName='code' minWidth={120} maxWidth={120} align='left' />
                <DataColumn kid='column2' name='Branca' fieldName='branchID' minWidth={120} maxWidth={120} align='left' />
                <DataColumn kid='column3' name='Descrizione' fieldName='description' minWidth={250} align='left' />
                <DataColumn kid='column4' name='Stato Precedente' fieldName='leap_DentalElementStatePreviousDescription' minWidth={250} align='left' />
                <DataColumn kid='column5' name='Stato Successivo' fieldName='leap_DentalElementStateNextDescription' minWidth={250} align='left' />
            </DataList>
        </>
    );
}